import React, { useEffect, useState } from 'react'; 
import Sidebar from './Sidebar'; 
import axios from 'axios';
import { BASE_URL, BASE_PAYMENT_URL } from './../../Environment';
import { toast } from 'react-toastify';
import Info from './Info';
import styles from './../../Assets/CSS/Register.module.css';
import inputStyles from './../../Assets/CSS/Input.module.css';
import { BlueButton } from './../../Components/Button';

function AdsCreate() {
    const accessToken = localStorage.getItem('accessToken'); 
    const [isCreateLoading, setIsCreateLoading] = useState(false);
    const [page, setPage] = useState('');
    const [location_list, setLocationList] = useState([]); 
    const [position, setPosition] = useState(''); 
    const [from_date, setFromDate] = useState('');
    const [to_date, setToDate] = useState(''); 
    const [location, setLocation] = useState('');  
    const [upload_image, setUploadImage] = useState(''); 
    const today = new Date().toISOString().split('T')[0];   
    const imageSizeConfig = {
        'Home': {
            'Top': '615 x 175',
            'Center': '615 x 175',
            'Bottom': '615 x 175' 
        }, 
        'Inner': {
            'Top': '615 x 175',
            'Center': '615 x 175', 
            'Bottom': '615 x 175'
        }
    };  
    const getRecommendedSize = () => {
        if (page && position && imageSizeConfig[page] && imageSizeConfig[page][position]) {
            return imageSizeConfig[page][position];
        }
        return null;
    }; 
    useEffect(() => {
        document.title = 'Infomart | Client Ads Create';
        axios.get(`${BASE_URL}/location`, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((res) => {
            setLocationList(res.data.data);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
        }); 
    }, []);   
    const handleImage = (e) => {
        const file = e.target.files[0];
        if (file) {
            setUploadImage(file); 
        } 
    }   
    const handleSubmit = async () => {
        setIsCreateLoading(true);
        if (upload_image) {
            const formData = new FormData(); 
            formData.append('page', page);
            formData.append('position', position);
            formData.append('from_date', from_date);
            formData.append('to_date', to_date);
            formData.append('location', location); 
            formData.append('file', upload_image); 
            await axios.post(`${BASE_URL}/vendor/ads/create`, formData, {
                headers: { 
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${accessToken}`
                }
            }).then((res) => { 
                toast.success(res.data.msg, { autoClose: 3000 });
                setIsCreateLoading(false);
                const id = res.data.id; 
                axios.post(`${BASE_URL}/vendor/ads/payment`, { id }, {
                    headers: {      
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${accessToken}`
                    }
                }).then((res) => {  
                    if (res.data.encrypted_data && res.data.access_code) { 
                        const form = document.createElement('form');
                        form.method = 'post';
                        form.action = BASE_PAYMENT_URL;  
                        const encRequestInput = document.createElement('input');
                        encRequestInput.type = 'hidden';
                        encRequestInput.name = 'encRequest';
                        encRequestInput.id = 'encRequest';
                        encRequestInput.value = res.data.encrypted_data;
                        form.appendChild(encRequestInput); 
                        const accessCodeInput = document.createElement('input');
                        accessCodeInput.type = 'hidden';
                        accessCodeInput.name = 'access_code';
                        accessCodeInput.id = 'access_code';
                        accessCodeInput.value = res.data.access_code;
                        form.appendChild(accessCodeInput); 
                        document.body.appendChild(form); 
                        form.submit(); 
                    }    
                }).catch((res) => {  
                    toast.error(res.response.data.msg, { autoClose: 3000 }); 
                }); 
            }).catch((res) => { 
                toast.error(res.response.data.msg, { autoClose: 3000 });
                setIsCreateLoading(false);
            });
        } else {
            toast.error('Select your image first.', { autoClose: 3000 });
            setIsCreateLoading(false);
        }  
    } 
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    <div className={styles.individualFormContainer} style={{ width: '100%', marginBottom: 0 }}>
                        <div className={styles.top}>
                            <div className="w-100">
                                <h4 className="text-center">Create New Ads</h4>
                            </div> 
                        </div> 
                        {getRecommendedSize() && (
                            <div style={{
                                background: '#f8f9fa',
                                border: '1px solid #dee2e6',
                                borderRadius: '8px',
                                padding: '15px',
                                marginBottom: '20px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px'
                            }}>
                                <div style={{
                                    backgroundColor: '#125fdc',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '24px',
                                    height: '24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                }}>
                                    i
                                </div>
                                <div>
                                    <strong>Recommended Image Size:</strong> {getRecommendedSize()} pixels
                                    <small style={{ display: 'block', color: '#666', marginTop: '4px' }}>
                                        For {page} page - {position} position
                                    </small>
                                </div>
                            </div>
                        )} 
                        <div id="input-city" className={styles.row}>
                            <div  className="col">
                                <label className="mb-2">Page *</label>
                                <select className={inputStyles.dropdown} onChange={e => setPage(e.target.value)} value={page}>
                                    <option value="" disabled>--</option>
                                    <option value="Home">Home</option>
                                    <option value="Inner">Inner</option>
                                </select> 
                            </div>
                            <div className="col">
                                <label className="mb-2">Position *</label>
                                <select className={inputStyles.dropdown} onChange={e => setPosition(e.target.value)} value={position}>
                                    <option value="" disabled>--</option>
                                    <option value="Top">Top</option> 
                                    <option value="Center">Center</option>
                                    <option value="Bottom">Bottom</option> 
                                </select> 
                            </div> 
                        </div>
                        <div id="input-city" className={styles.row}>
                            <div className="col">
                                <label className="mb-2">From Date *</label>
                                <input type="date" className={inputStyles.input} min={today} onChange={e => setFromDate(e.target.value)} value={from_date} />
                            </div>
                            <div className="col">
                                <label className="mb-2">To Date *</label>
                                <input type="date" className={inputStyles.input} min={today} onChange={e => setToDate(e.target.value)} value={to_date} /> 
                            </div> 
                        </div> 
                        <div id="input-city" className={styles.row}>
                            <div className="col">
                                <label className="mb-2">Location *</label>
                                <select className={inputStyles.dropdown} onChange={e => setLocation(e.target.value)} value={location}>
                                    <option value="" disabled>--</option>
                                    <option value="All Location">All Location</option>
                                    {location_list?.map((location_item, index) => (
                                        <option key={index} value={location_item.location}>{location_item.location}</option>
                                    ))}  
                                </select>    
                            </div> 
                            <div className="col">
                                <label className="mb-2">
                                    Image * 
                                    {getRecommendedSize() && (
                                        <span style={{ color: '#125fdc', fontSize: '12px', fontWeight: 'normal' }}>
                                            ({getRecommendedSize()})
                                        </span>
                                    )}
                                </label>
                                <input type="file" className={inputStyles.input} accept="image/*" onChange={(e) => handleImage(e)} /> 
                            </div>   
                        </div>    
                        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                            <details style={{ 
                                background: '#f8f9fa', 
                                border: '1px solid #dee2e6', 
                                borderRadius: '8px', 
                                padding: '15px' 
                            }}>
                                <summary style={{ 
                                    cursor: 'pointer', 
                                    fontWeight: 'bold', 
                                    color: '#125fdc',
                                    marginBottom: '10px'
                                }}>
                                    📏 View All Image Size Guidelines
                                </summary>
                                <div style={{ marginTop: '15px' }}>
                                    <h6 style={{ marginBottom: '10px', color: '#333' }}>Home Page:</h6>
                                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                        <li style={{ padding: '5px 0', borderBottom: '1px solid #eee' }}>Top: <strong>615 x 175</strong> pixels</li>
                                        <li style={{ padding: '5px 0', borderBottom: '1px solid #eee' }}>Center: <strong>615 x 175</strong> pixels</li>  
                                        <li style={{ padding: '5px 0' }}>Bottom: <strong>615 x 175</strong> pixels</li>  
                                    </ul>
                                    <h6 style={{ marginTop: '15px', marginBottom: '10px', color: '#333' }}>Inner Page:</h6>
                                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                        <li style={{ padding: '5px 0', borderBottom: '1px solid #eee' }}>Top: <strong>615 x 175</strong> pixels</li>
                                        <li style={{ padding: '5px 0', borderBottom: '1px solid #eee' }}>Center: <strong>615 x 175</strong> pixels</li> 
                                        <li style={{ padding: '5px 0' }}>Bottom: <strong>615 x 175</strong> pixels</li> 
                                    </ul>
                                </div>
                            </details>
                        </div> 
                        <div className="mt-4">
                            <BlueButton title={isCreateLoading ? "Loading..." : "Submit"} onClick={() => handleSubmit()} />
                        </div>
                    </div>  
                </div> 
            </div> 
        </div>
    );
}

export default AdsCreate; 